import { useSearcher } from "../search/components/SearcherContext";
import {useEffect, useState} from "react";

export function useAnnotationsToggle() {
    const searcher = useSearcher();

    const [showAnnotations, setShowAnnotations] = useState(
        searcher.showAnnotations
    );

    useEffect(() => {
        //upon mounting, subscribe to showAnnotations updates from the searcher
        const subscription = searcher.subscribe(
            "update.showAnnotations",
            setShowAnnotations
        );
        return () => {
            //upon destroying, unsubscribe to prevent mem-leaks and more badness
            searcher.unsubscribe("update.showAnnotations", subscription);
        };
    }, [showAnnotations, searcher]);

    return {showAnnotations, toggleAnnotations: searcher.toggleAnnotations};
}